export default "__VITE_ASSET__BPijYgGa__"